import { COUNTIES, PROVINCES } from "./regions";
import { defaultDesign, statsFor } from "./shield";
import { KIDS } from "./samples";

const COUNTY_INFO = {
  ant: ["the Saffrons", "saffron and white"], arm: ["the Orchard County", "orange and white"], car: ["the Dolmen County", "red, green and yellow"],
  cav: ["the Breffni County", "blue and white"], cla: ["the Banner County", "saffron and blue"], cor: ["the Rebel County", "red and white"],
  der: ["the Oak Leaf County", "red and white"], don: ["Tír Chonaill", "green and gold"], dow: ["the Mourne County", "red and black"],
  dub: ["the Dubs", "sky blue and navy"], fer: ["the Ernesiders", "green and white"], gal: ["the Tribesmen", "maroon and white"],
  ker: ["the Kingdom", "green and gold"], kid: ["the Lilywhites", "all white"], kik: ["the Cats", "black and amber"],
  lao: ["the O'Moore County", "blue and white"], lei: ["the Ridge County", "green and gold"], lim: ["the Treaty County", "green and white"],
  lon: ["the Slashers", "blue and gold"], lou: ["the Wee County", "red and white"], may: ["the Green and Red", "green and red"],
  mea: ["the Royal County", "green and gold"], mon: ["the Farney County", "white and blue"], off: ["the Faithful County", "green, white and gold"],
  ros: ["the Rossies", "primrose and blue"], sli: ["the Yeats County", "black and white"], tip: ["the Premier County", "blue and gold"],
  tyr: ["the Red Hand County", "red and white"], wat: ["the Déise", "white and blue"], wes: ["the Lake County", "maroon and white"],
  wex: ["the Model County", "purple and gold"], wic: ["the Garden County", "blue and gold"],
  ldn: ["the Exiles", "green and white"], nyc: ["Overseas GAA", "navy and red"], war: ["Overseas GAA", "blue and white"],
  lan: ["Overseas GAA", "red and white"], sco: ["Overseas GAA", "blue and white"],
};
const PROVINCE_INFO = {
  mun: ["Munster", "red", ["#C8102E", "#FFFFFF"]], lei: ["Leinster", "blue", ["#1D4ED8", "#F5C542"]],
  uls: ["Ulster", "white and red", ["#C8102E", "#FFFFFF"]], con: ["Connacht", "green", ["#047857", "#FFFFFF"]],
};

const slugOf = (name) => name.toLowerCase().replace(/[^a-z0-9]+/g, "-");
const lum = (hex) => { const [r, g, b] = [1, 3, 5].map((i) => parseInt(hex.slice(i, i + 2), 16)); return 0.299 * r + 0.587 * g + 0.114 * b; };
const OVERSEAS = ["ldn", "nyc", "war", "lan", "sco"];

export const GAA_PAGES = COUNTIES.map(([id, name, code, a, b]) => {
  const [dark, light] = lum(a) <= lum(b) ? [a, b] : [b, a];
  return { id, name, code, slug: slugOf(name), sport: "gaa", kind: "county", nick: COUNTY_INFO[id][0], colourText: COUNTY_INFO[id][1],
    overseas: OVERSEAS.includes(id), colours: lum(dark) > 200 ? ["#0F172A", "#FFFFFF"] : [dark, light] };
});
export const RUGBY_PAGES = PROVINCES.map(([id, name, code]) => ({ id, name, code, slug: slugOf(name), sport: "rugby", kind: "province",
  nick: `${PROVINCE_INFO[id][0]} rugby`, colourText: PROVINCE_INFO[id][1], colours: PROVINCE_INFO[id][2] }));
export const pageFor = (sport, slug) => (sport === "rugby" ? RUGBY_PAGES : GAA_PAGES).find((p) => p.slug === slug);
export const pagePath = (p) => `/${p.sport}/${p.slug}`;

const KID_BY_COLOUR = { "#047857": "gaa", "#15803D": "gaa", "#7A1F2B": "hurling", "#C8102E": "hurling", "#1D4ED8": "camogie", "#1E3A8A": "camogie",
  "#0F1E3D": "camogie", "#6D28D9": "camogie", "#7DD3FC": "camogie", "#111111": "hurling2", "#F2B705": "hurling2", "#F97316": "hurling2" };
const kidFor = (p) => (p.sport === "rugby" ? (p.id === "lei" ? "rugbyGirl" : "rugby") : KID_BY_COLOUR[p.colours[0]] || "gaa");

// Designer start point in the page's colours with its badge (optionally with a sample photo).
export const regionDesign = (p, { sample = false } = {}) => {
  const d = defaultDesign();
  const [primary, secondary] = p.colours;
  const design = {
    ...d, sport: p.sport,
    colours: { primary, secondary, accent: secondary, border: secondary, text: lum(primary) > 140 ? "#0F172A" : "#FFFFFF" },
    background: { ...d.background, style: "stripes", variant: "vertical" },
    flag: { ...d.flag, kind: p.kind, [p.kind]: p.id },
    player: { ...d.player, position: "", clubName: p.overseas || p.sport === "rugby" ? `${p.name} ${p.sport === "rugby" ? "Minis" : "GAA"}` : `${p.name} U12` },
    stats: Object.fromEntries(statsFor(p.sport).map((s) => [s.key, ""])),
  };
  if (!sample) return design;
  const vals = [86, 82, 79, 88, 74, 90];
  return { ...design, guide: false, photo: { ...d.photo, file: KIDS[kidFor(p)], zoom: 1.15, x: 18, y: 42, fade: true },
    player: { ...design.player, name: "Your Star", rating: "88", position: "custom", customPosition: p.sport === "rugby" ? "FH" : "MF" },
    stats: Object.fromEntries(statsFor(p.sport).map((s, i) => [s.key, String(vals[i])])) };
};
